/**
 * Formats a decimal value as a percentage with one decimal place
 * @param value - The decimal value (e.g., 0.1234 for 12.34%)
 * @returns Formatted percentage string (e.g., "12.3%")
 */
export function formatPercentage(value: number | null | undefined): string {
  if (value === null || value === undefined) {
    return '0%'
  }
  return `${(value * 100).toFixed(1)}%`
}
